const COLOR_STOPS = [
  { pct: 0, color: '#EB5757' },
  { pct: 35, color: '#F2994A' },
  { pct: 55, color: '#F2C94C' },
  { pct: 70, color: '#27AE60' },
  { pct: 100, color: '#27AE60' },
]

const clamp = (value: number, min: number, max: number) => Math.min(max, Math.max(min, value))

const hexToRgb = (hex: string) => {
  const sanitized = hex.replace('#', '')
  const normalized =
    sanitized.length === 3
      ? sanitized
          .split('')
          .map((char) => `${char}${char}`)
          .join('')
      : sanitized
  const parsed = Number.parseInt(normalized, 16)
  return {
    r: (parsed >> 16) & 255,
    g: (parsed >> 8) & 255,
    b: parsed & 255,
  }
}

const rgbToHex = ({ r, g, b }: { r: number; g: number; b: number }) =>
  `#${[r, g, b]
    .map((channel) => clamp(Math.round(channel), 0, 255).toString(16).padStart(2, '0'))
    .join('')}`

export const getGaugeColorByPercent = (percentual: number) => {
  const percent = clamp(percentual, 0, 100)
  let currentStop = COLOR_STOPS[0]
  let nextStop = COLOR_STOPS[COLOR_STOPS.length - 1]

  for (let i = 0; i < COLOR_STOPS.length - 1; i += 1) {
    const from = COLOR_STOPS[i]
    const to = COLOR_STOPS[i + 1]
    if (percent >= from.pct && percent <= to.pct) {
      currentStop = from
      nextStop = to
      break
    }
  }

  if (currentStop.pct === nextStop.pct) return currentStop.color

  const ratio = (percent - currentStop.pct) / (nextStop.pct - currentStop.pct)
  const start = hexToRgb(currentStop.color)
  const end = hexToRgb(nextStop.color)

  return rgbToHex({
    r: start.r + (end.r - start.r) * ratio,
    g: start.g + (end.g - start.g) * ratio,
    b: start.b + (end.b - start.b) * ratio,
  })
}

